import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Klantenboek.css';
import api from '../services/api';
import { QRCodeSVG } from 'qrcode.react';

const Klantenboek = () => {
  const { terms, organisatieModus } = useAuth();
  const { gebruiker } = useAuth();
  const navigate = useNavigate();
  const [klanten, setKlanten] = useState([]);
  const [catNieuw, setCatNieuw] = useState(false);
  const [subNieuw, setSubNieuw] = useState(false);
  const [opdrachtgevers, setOpdrachtgevers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showQrExport, setShowQrExport] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategorie, setSelectedCategorie] = useState(localStorage.getItem('klantenCategorie') || '');
  const [selectedSubcat, setSelectedSubcat] = useState('');
  const [formData, setFormData] = useState({
    klant_id: '', naam: '', contactpersoon: '', adres: '', postcode: '', plaats: '', telefoon: '', email: '', notities: '', categorie: '', subcategorie: '',
    partner_naam: '', partner_email: '', partner_telefoon: '',
    bedrijf_naam: '', kvk_nummer: '', btw_nummer: '', factuuradres: ''
  });

  const location = useLocation();
  const [opdrFilter, setOpdrFilter] = useState(() => new URLSearchParams(window.location.search).get('opdrachtgever_id') || '');
  useEffect(() => {
    api.get('/opdrachtgevers').then(r => setOpdrachtgevers(r.data && r.data.opdrachtgevers ? r.data.opdrachtgevers : [])).catch(() => {});
  }, []);
  useEffect(() => {
    setOpdrFilter(new URLSearchParams(location.search).get('opdrachtgever_id') || '');
  }, [location.search]);
  useEffect(() => {
    loadKlanten();
  }, [opdrFilter]);

  const loadKlanten = async () => {
    try {
      const response = await api.get(opdrFilter ? '/klanten?opdrachtgever_id=' + opdrFilter : '/klanten');
      setKlanten(response.data.klanten || []);
      setLoading(false);
    } catch (error) {
      console.error('Fout bij laden klanten:', error);
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.naam) {
      alert('Naam is verplicht');
      return;
    }
    try {
      await api.post('/klanten', formData);
      setShowModal(false);
      setFormData({ naam: '', contactpersoon: '', adres: '', postcode: '', plaats: '', telefoon: '', email: '', notities: '', categorie: '', subcategorie: '' });
      loadKlanten();
    } catch (error) {
      alert(error.response?.data?.message || 'Fout bij aanmaken klant');
    }
  };

  const handleDelete = async (e, klantId, klantNaam) => {
    e.stopPropagation();
    if (!window.confirm(`Weet je zeker dat je klant "${klantNaam}" wilt verwijderen?\n\nDit kan niet ongedaan worden gemaakt.`)) return;
    try {
      await api.delete(`/klanten/${klantId}`);
      loadKlanten();
      alert('Klant succesvol verwijderd');
    } catch (error) {
      alert(error.response?.data?.message || 'Fout bij verwijderen klant');
    }
  };

  const uniqueCategorieen = [...new Set(klanten.map(k => k.categorie).filter(Boolean))];
  const subsVoorCat = (cat) => [...new Set(klanten.filter(k => k.categorie === cat).map(k => k.subcategorie).filter(Boolean))].sort((a, b) => a.localeCompare(b));
  const uniqueSubcats = selectedCategorie ? [...new Set(klanten.filter(k => k.categorie === selectedCategorie).map(k => k.subcategorie).filter(Boolean))] : [];
  const filteredKlanten = klanten.filter(klant => {
    const matchSearch = klant.naam.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (klant.plaats && klant.plaats.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (klant.contactpersoon && klant.contactpersoon.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (klant.categorie && klant.categorie.toLowerCase().includes(searchTerm.toLowerCase()));
    const matchCategorie = !selectedCategorie || klant.categorie === selectedCategorie;
    const matchSubcat = !selectedSubcat || klant.subcategorie === selectedSubcat;
    return matchSearch && matchCategorie && matchSubcat;
  });

  if (loading) return <div className="loading-screen">Laden...</div>;

  return (
    <>
      <div className="klantenboek">
        <div className="dashboard-container">
          <div className="dashboard-header">
            <h1>📖 {terms?.klant_plural || "Klanten"} & Locaties</h1>
          </div>

          <div style={{ padding: '15px 0', borderBottom: '1px solid #e5e7eb', marginBottom: '20px', display: 'flex', gap: '10px', alignItems: 'center' }}>
            <input
              type="text"
              placeholder={`🔍 Zoek ${(terms?.klant_singular || "klant").toLowerCase()}, plaats...`}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #d1d5db', fontSize: '14px' }}
            />
            <button onClick={() => setShowModal(true)} className="btn-primary">+ Nieuwe {terms?.klant_singular || "klant"}</button>
            <button onClick={() => setShowQrExport(true)} className="btn-primary" style={{ marginLeft: 8 }}>🖨 Alle QR's</button>
            {showQrExport && <QrExportModal onClose={() => setShowQrExport(false)} />}
          </div>

          {uniqueCategorieen.length > 0 && (
            <div style={{ display: 'flex', gap: '8px', marginBottom: '15px', flexWrap: 'wrap' }}>
              <button onClick={() => { setSelectedCategorie(''); setSelectedSubcat(''); localStorage.setItem('klantenCategorie', ''); }} style={{ padding: '6px 12px', borderRadius: '20px', border: 'none', background: selectedCategorie === '' ? '#3b82f6' : '#e5e7eb', color: selectedCategorie === '' ? 'white' : '#374151', cursor: 'pointer', fontSize: '13px' }}>Alle</button>
              {uniqueCategorieen.map(cat => (
                <button key={cat} onClick={() => { setSelectedCategorie(cat); setSelectedSubcat(''); localStorage.setItem('klantenCategorie', cat); }} style={{ padding: '6px 12px', borderRadius: '20px', border: 'none', background: selectedCategorie === cat ? '#3b82f6' : '#e5e7eb', color: selectedCategorie === cat ? 'white' : '#374151', cursor: 'pointer', fontSize: '13px' }}>{cat}</button>
              ))}
            </div>
          )}

          {selectedCategorie && uniqueSubcats.length > 0 && (
            <div style={{ display: 'flex', gap: '8px', marginBottom: '15px', flexWrap: 'wrap', paddingLeft: '12px', borderLeft: '3px solid #3b82f6' }}>
              <span style={{ fontSize: '12px', color: '#6b7280', alignSelf: 'center', marginRight: '4px' }}>{selectedCategorie}:</span>
              <button onClick={() => setSelectedSubcat('')} style={{ padding: '6px 12px', borderRadius: '20px', border: 'none', background: selectedSubcat === '' ? '#3b82f6' : '#e5e7eb', color: selectedSubcat === '' ? 'white' : '#374151', cursor: 'pointer', fontSize: '13px' }}>Alle</button>
              {uniqueSubcats.map(sub => (
                <button key={sub} onClick={() => setSelectedSubcat(sub)} style={{ padding: '6px 12px', borderRadius: '20px', border: 'none', background: selectedSubcat === sub ? '#3b82f6' : '#e5e7eb', color: selectedSubcat === sub ? 'white' : '#374151', cursor: 'pointer', fontSize: '13px' }}>{sub}</button>
              ))}
            </div>
          )}
          <div className="dashboard-stats">
            <div className="stat-card">
              <div className="stat-number">{klanten.length}</div>
              <div className="stat-label">Totaal {terms?.klant_plural || "Klanten"}</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">{klanten.filter(k => k.openstaand_restwerk > 0).length}</div>
              <div className="stat-label">Met Restwerk</div>
            </div>
          </div>

          <div className="werkorders-section">
            {opdrFilter && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12, padding: '10px 14px', background: '#e6fffa', border: '1px solid #00D4AA', borderRadius: 8 }}>
                <span style={{ fontSize: 14, color: '#0a7d66' }}>Objecten van: <strong>{(opdrachtgevers.find(o => String(o.id) === String(opdrFilter)) || {}).naam || 'opdrachtgever'}</strong></span>
                <button onClick={() => navigate('/klanten')} style={{ padding: '4px 12px', background: '#fff', border: '1px solid #00D4AA', color: '#0a7d66', borderRadius: 6, cursor: 'pointer', fontSize: 13 }}>Toon alles</button>
              </div>
           )}
            <h2>{terms?.klant_plural || "Klanten"} Overzicht</h2>
            {filteredKlanten.length === 0 ? (
              <div className="no-werkorders">
                <p>Geen {(terms?.klant_plural || "klanten").toLowerCase()} gevonden</p>
                {klanten.length === 0 && (
                  <button onClick={() => setShowModal(true)} className="btn-primary">Voeg je eerste {(terms?.klant_singular || "klant").toLowerCase()} toe</button>
                )}
              </div>
            ) : (
              <div className="werkorders-list">
                {filteredKlanten.map(klant => (
                  <div key={klant.id} className="werkorder-card" onClick={() => navigate(`/klant/${klant.id}`)}>
                    <div className="werkorder-header">
                      <div className="werkorder-title-row">
                        <h3>📖 {klant.naam}{klant.categorie && <span style={{ background: "#e0f2fe", color: "#0369a1", padding: "2px 8px", borderRadius: "4px", fontSize: "11px", marginLeft: "8px" }}>{klant.categorie}</span>}{klant.subcategorie && <span style={{ background: "#fef3c7", color: "#92400e", padding: "2px 8px", borderRadius: "4px", fontSize: "11px", marginLeft: "4px" }}>{klant.subcategorie}</span>}</h3>
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                          {(gebruiker?.rol === 'werkvoorbereider' || gebruiker?.rol === 'bedrijf_admin' || gebruiker?.rol === 'super_admin') && (
                            <button onClick={(e) => handleDelete(e, klant.id, klant.naam)} title="Verwijder klant" style={{ background: 'none', border: 'none', fontSize: '1.2rem', cursor: 'pointer', padding: '4px 8px', borderRadius: '4px', opacity: 0.6 }}>🗑️</button>
                          )}
                          {klant.openstaand_restwerk > 0 && (
                            <span style={{ background: '#fef3c7', color: '#92400e', padding: '4px 8px', borderRadius: '4px', fontSize: '12px' }}>⚠️ {klant.openstaand_restwerk} restwerk</span>
                          )}
                        </div>
                      </div>
                    </div>
                    {klant.contactpersoon && (<p className="werkorder-meta" style={{ marginTop: '8px' }}>👤 {klant.contactpersoon}</p>)}
                    <div className="werkorder-meta">
                      {klant.adres && <span>📍 {klant.adres}{klant.plaats && `, ${klant.plaats}`}</span>}
                      {klant.telefoon && <span>📞 {klant.telefoon}</span>}
                      {klant.aantal_logs > 0 && (<span>📋 {klant.aantal_logs} logs</span>)}
                      {klant.onderhoud_laatst && <span style={{ color: '#059669', fontWeight: 600 }}>✅ {new Date(klant.onderhoud_laatst).toLocaleDateString('nl-NL')}</span>}
                      {klant.onderhoud_volgende && <span style={{ color: '#3b82f6', fontWeight: 600 }}>📅 {new Date(klant.onderhoud_volgende).toLocaleDateString('nl-NL')}</span>}
                      {klant.onderhoud_frequentie && <span style={{ color: '#6b7280' }}>{klant.onderhoud_frequentie}</span>}
                    </div>

                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {showModal && (
        <div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center'}} onClick={() => setShowModal(false)}>
          <div className="modal-content klant-modal" style={{maxWidth: 600, width: '92%'}} onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Nieuwe Klant/Locatie</h2>
              <button onClick={() => setShowModal(false)} className="btn-close">×</button>
            </div>
            <form onSubmit={handleSubmit}>
              {organisatieModus === 'klant' && (
                <div className="form-group">
                  <label>Opdrachtgever *</label>
                  <select value={formData.klant_id} onChange={(e) => setFormData({...formData, klant_id: e.target.value})} required>
                    <option value="">— kies opdrachtgever —</option>
                    {opdrachtgevers.map(o => <option key={o.id} value={o.id}>{o.naam}</option>)}
                  </select>
                </div>
              )}
              <div className="form-group">
                <label>Bedrijfsnaam/Locatienaam *</label>
                <input type="text" value={formData.naam} onChange={(e) => setFormData({...formData, naam: e.target.value})} placeholder="Bijv. Kantoor ABC, Gemeente X" required />
              </div>
              <div className="form-group">
                <label>Contactpersoon</label>
                <input type="text" value={formData.contactpersoon} onChange={(e) => setFormData({...formData, contactpersoon: e.target.value})} placeholder="Naam van contactpersoon" />
              </div>
              <div className="form-group">
                <label>Adres</label>
                <input type="text" value={formData.adres} onChange={(e) => setFormData({...formData, adres: e.target.value})} placeholder="Straat + huisnummer" />
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Postcode</label>
                  <input type="text" value={formData.postcode} onChange={(e) => setFormData({...formData, postcode: e.target.value})} placeholder="1234 AB" />
                </div>
                <div className="form-group">
                  <label>Plaats</label>
                  <input type="text" value={formData.plaats} onChange={(e) => setFormData({...formData, plaats: e.target.value})} placeholder="Amsterdam" />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Telefoon</label>
                  <input type="tel" value={formData.telefoon} onChange={(e) => setFormData({...formData, telefoon: e.target.value})} placeholder="06-12345678" />
                </div>
                <div className="form-group">
                  <label>Email</label>
                  <input type="email" value={formData.email} onChange={(e) => setFormData({...formData, email: e.target.value})} placeholder="contact@bedrijf.nl" />
                </div>
              </div>
              <div style={{borderTop: '1px solid #e2e8f0', marginTop: 16, paddingTop: 16}}>
                <h3 style={{margin: '0 0 12px 0', fontSize: 14, fontWeight: 600, color: '#64748b'}}>
                  Partner (optioneel)
                </h3>
                <div className="form-group">
                  <label>Naam partner</label>
                  <input type="text" value={formData.partner_naam} onChange={(e) => setFormData({...formData, partner_naam: e.target.value})} placeholder="Naam van partner" />
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Email partner</label>
                    <input type="email" value={formData.partner_email} onChange={(e) => setFormData({...formData, partner_email: e.target.value})} placeholder="partner@email.nl" />
                  </div>
                  <div className="form-group">
                    <label>06-nummer partner</label>
                    <input type="tel" value={formData.partner_telefoon} onChange={(e) => setFormData({...formData, partner_telefoon: e.target.value})} placeholder="06-12345678" />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <label>Categorie</label>
                {!catNieuw ? (
                  <select value={formData.categorie} onChange={(e) => {
                    if (e.target.value === '__nieuw__') { setCatNieuw(true); setSubNieuw(true); setFormData({...formData, categorie: '', subcategorie: ''}); }
                    else { setSubNieuw(false); setFormData({...formData, categorie: e.target.value, subcategorie: ''}); }
                  }}>
                    <option value="">— Kies categorie —</option>
                    {[...uniqueCategorieen].sort((a, b) => a.localeCompare(b)).map(c => <option key={c} value={c}>{c}</option>)}
                    <option value="__nieuw__">+ Nieuwe categorie…</option>
                  </select>
                ) : (
                  <div style={{ display: 'flex', gap: 8 }}>
                    <input type="text" autoFocus value={formData.categorie} onChange={(e) => setFormData({...formData, categorie: e.target.value})} placeholder="Nieuwe categorie" />
                    <button type="button" className="btn-secondary" title="Terug naar keuzelijst" onClick={() => { setCatNieuw(false); setSubNieuw(false); setFormData({...formData, categorie: '', subcategorie: ''}); }}>↩</button>
                  </div>
                )}
              </div>
              <div className="form-group">
                <label>Subcategorie (optioneel)</label>
                {(!subNieuw && subsVoorCat(formData.categorie).length > 0) ? (
                  <select value={formData.subcategorie} onChange={(e) => {
                    if (e.target.value === '__nieuw__') { setSubNieuw(true); setFormData({...formData, subcategorie: ''}); }
                    else { setFormData({...formData, subcategorie: e.target.value}); }
                  }}>
                    <option value="">— Geen / kies —</option>
                    {subsVoorCat(formData.categorie).map(s => <option key={s} value={s}>{s}</option>)}
                    <option value="__nieuw__">+ Nieuwe subcategorie…</option>
                  </select>
                ) : (
                  <div style={{ display: 'flex', gap: 8 }}>
                    <input type="text" value={formData.subcategorie} onChange={(e) => setFormData({...formData, subcategorie: e.target.value})} placeholder="Bijv. CT1, CT2, RA, HS, UHC..." />
                    {subNieuw && subsVoorCat(formData.categorie).length > 0 && (
                      <button type="button" className="btn-secondary" title="Terug naar keuzelijst" onClick={() => { setSubNieuw(false); setFormData({...formData, subcategorie: ''}); }}>↩</button>
                    )}
                  </div>
                )}
              </div>
              <div style={{borderTop: '1px solid #e2e8f0', marginTop: 16, paddingTop: 16}}>
                <h3 style={{margin: '0 0 12px 0', fontSize: 14, fontWeight: 600, color: '#64748b'}}>
                  Bedrijfsgegevens (indien zakelijk)
                </h3>
                <div className="form-group">
                  <label>Bedrijfsnaam</label>
                  <input type="text" value={formData.bedrijf_naam} onChange={(e) => setFormData({...formData, bedrijf_naam: e.target.value})} placeholder="Bijv. Acme BV" />
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>KvK-nummer</label>
                    <input type="text" value={formData.kvk_nummer} onChange={(e) => setFormData({...formData, kvk_nummer: e.target.value})} placeholder="12345678" />
                  </div>
                  <div className="form-group">
                    <label>BTW-nummer</label>
                    <input type="text" value={formData.btw_nummer} onChange={(e) => setFormData({...formData, btw_nummer: e.target.value})} placeholder="NL123456789B01" />
                  </div>
                </div>
                <div className="form-group">
                  <label>Factuuradres (indien anders)</label>
                  <input type="text" value={formData.factuuradres} onChange={(e) => setFormData({...formData, factuuradres: e.target.value})} placeholder="Indien anders dan adres hierboven" />
                </div>
              </div>
              <div className="form-group">
                <label>Notities</label>
                <textarea value={formData.notities} onChange={(e) => setFormData({...formData, notities: e.target.value})} placeholder="Bijv. toegangscode, speciale instructies..." rows="3" />
              </div>
              <div className="modal-actions">
                <button type="button" onClick={() => setShowModal(false)} className="btn-secondary">Annuleren</button>
                <button type="submit" className="btn-primary">Klant Aanmaken</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default Klantenboek;

function QrExportModal({ onClose }) {
  const [locs, setLocs] = useState([]);
  const [laden, setLaden] = useState(true);
  const [zoek, setZoek] = useState('');
  const [alleenInfo, setAlleenInfo] = useState(false);
  const FORMATEN = {
    '70x37':  { label: '3 per rij (24 per A4)', cols: 3, rijen: 8, qr: 22, t: 9,  a: 5.5, r: 6.5 },
    '105x57': { label: '2 per rij (10 per A4)', cols: 2, rijen: 5, qr: 38, t: 13, a: 8,   r: 9 },
    '105x74': { label: '2 per rij (8 per A4)',  cols: 2, rijen: 4, qr: 50, t: 16, a: 9,   r: 10.5 },
  };
  const [fmt, setFmt] = useState('105x57');
  const [marge, setMarge] = useState(8);
  const FM = FORMATEN[fmt];
  const per = FM.cols * FM.rijen;

  useEffect(() => {
    api.get('/klanten/qr-export')
      .then(r => setLocs(r.data.locaties || []))
      .catch(() => alert('Laden mislukt'))
      .finally(() => setLaden(false));
  }, []);

  const adres = (k) => [k.adres, [k.postcode, k.plaats || k.stad || k.woonplaats].filter(Boolean).join(' ')].filter(Boolean).join(', ');
  const z = zoek.trim().toLowerCase();
  const lijst = locs.filter(k =>
    (!z || (k.naam || '').toLowerCase().includes(z) || adres(k).toLowerCase().includes(z)) &&
    (!alleenInfo || (k.qr_velden || []).length > 0));

  const esc = (t) => String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

  const print = () => {
    const m = Math.max(0, Number(marge) || 0);
    const cw = (210 - 2 * m) / FM.cols;
    const ch = (297 - 2 * m - 1) / FM.rijen;
    const qr = Math.min(FM.qr, ch - 6);
    const svgs = document.querySelectorAll('#qr-export-grid svg');
    const labels = lijst.map((k, i) => {
      const rows = (k.qr_velden || []).map(v => '<div class="r"><span class="n">' + esc(v.n) + '</span><span class="w">' + esc(v.w) + '</span></div>').join('');
      return '<div class="lbl">' + (svgs[i] ? svgs[i].outerHTML : '') + '<div class="i"><div class="t">' + esc(k.naam) + '</div><div class="a">' + esc(adres(k)) + '</div>' + rows + '</div></div>';
    });
    let pages = '';
    for (let p = 0; p < labels.length; p += per) pages += '<div class="pg">' + labels.slice(p, p + per).join('') + '</div>';
    const w = window.open('', '_blank');
    if (!w) { alert('Pop-up geblokkeerd'); return; }
    w.document.write('<html><head><title>QR-stickers</title><style>' +
      '@page{size:A4;margin:' + m + 'mm}*{box-sizing:border-box}html,body{margin:0;padding:0;font-family:Arial,sans-serif}' +
      '.pg{display:grid;grid-template-columns:repeat(' + FM.cols + ',' + cw + 'mm);grid-auto-rows:' + ch + 'mm;page-break-after:always;break-after:page}' +
      '.pg:last-child{page-break-after:auto;break-after:auto}' +
      '.lbl{display:flex;align-items:center;gap:2mm;padding:2mm 3mm;overflow:hidden;outline:0.2mm dashed #bbb;outline-offset:-0.1mm}' +
      '.lbl svg{width:' + qr + 'mm;height:' + qr + 'mm;flex:0 0 ' + qr + 'mm}' +
      '.i{flex:1;min-width:0;line-height:1.25}' +
      '.t{font-size:' + FM.t + 'pt;font-weight:bold;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
      '.a{font-size:' + FM.a + 'pt;color:#555;margin-bottom:1mm;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
      '.r{display:flex;justify-content:space-between;gap:1.5mm;font-size:' + FM.r + 'pt;border-bottom:0.1mm solid #ddd}' +
      '.n{min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
      '.w{flex-shrink:0;white-space:nowrap;font-weight:bold}' +
      '</style></head><body>' + pages + '</body></html>');
    w.document.close();
    setTimeout(() => w.print(), 400);
  };

  const inp = { padding: 8, border: '1px solid #d1d5db', borderRadius: 6, color: '#111827', background: '#fff' };

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: '#fff', color: '#111827', borderRadius: 10, padding: 20, width: 900, maxWidth: '95vw', maxHeight: '88vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <h3 style={{ margin: 0 }}>🖨 QR-stickers</h3>
          <button onClick={onClose} style={{ border: 'none', background: 'none', fontSize: 20, cursor: 'pointer' }}>×</button>
        </div>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 10, flexWrap: 'wrap' }}>
          <input value={zoek} onChange={e => setZoek(e.target.value)} placeholder="Filter op naam/adres (bijv. W0)" style={{ ...inp, flex: 1, minWidth: 200 }} />
          <select value={fmt} onChange={e => setFmt(e.target.value)} style={inp}>{Object.entries(FORMATEN).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}</select>
          <label style={{ fontSize: 13 }}>marge <input type="number" min="0" max="20" step="1" value={marge} onChange={e => setMarge(e.target.value)} style={{ ...inp, width: 55, padding: 6 }} /> mm</label>
          <label style={{ fontSize: 13 }}><input type="checkbox" checked={alleenInfo} onChange={e => setAlleenInfo(e.target.checked)} /> alleen met info</label>
          <span style={{ fontSize: 13, color: '#6b7280' }}>{lijst.length} stuks · {Math.ceil(lijst.length / per)} vel</span>
          <button className="btn-primary" onClick={print} disabled={laden || lijst.length === 0}>Printen</button>
        </div>
        <div id="qr-export-grid" style={{ overflow: 'auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(220px,1fr))', gap: 8 }}>
          {laden ? <p>Laden...</p> : lijst.map(k => (
            <div key={k.id} style={{ border: '1px solid #e5e7eb', borderRadius: 6, padding: 6, textAlign: 'center', fontSize: 11 }}>
              <QRCodeSVG value={`https://womsys.nl/monteurs-app?klant=${k.id}`} size={90} level="H" includeMargin={false} bgColor="#ffffff" fgColor="#1e40af" />
              <div style={{ fontWeight: 600, marginTop: 4 }}>{k.naam}</div>
              {(k.qr_velden || []).length === 0 ? <div style={{ color: '#dc2626' }}>geen info</div> : <div style={{ textAlign: 'left', marginTop: 4 }}>{k.qr_velden.map((v, j) => <div key={j} style={{ display: 'flex', justifyContent: 'space-between', gap: 6, borderBottom: '1px solid #f3f4f6', fontSize: 10 }}><span style={{ color: '#6b7280' }}>{v.n}</span><b>{v.w}</b></div>)}</div>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
